// TODO: wire to messages slice once it exists
export function useUnreadMessageCount(): number {
  return 0;
}
